<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import pm from "./components/common/protocolManager";
import eventBus from "./components/common/eventBus";
export default {
  name: "App",
  data: () => ({
    // dialogTableVisible: true
  }),
  mounted() {},

  created() {
    if (localStorage.authToken) {
      pm.setAuthToken(localStorage.authToken);
    }

    testData1 = this;
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue